import { BsTelegram, BsGithub, BsLinkedin } from 'react-icons/bs';
import styled from 'styled-components';

const SocialIconsForm = (props) => {
  const socialNetworks = [
    {
      name: 'Github',
      link: 'https://github.com/Itzabelli',
      logo: <BsGithub />,
    },
    {
      name: 'LinkedIn',
      link: 'https://www.linkedin.com/',
      logo: <BsLinkedin />,
    },
    {
      name: 'Telegram',
      link: 'https://t.me/Itzabelli',
      logo: <BsTelegram />,
    },
  ];
  return (
    <div className={props.className}>
      {socialNetworks.map((network, name) => (
        <a
          className="Icon"
          key={name}
          href={network.link}
          target="__blank"
          rel="noreferrer"
        >
          <>{network.logo}</>
        </a>
      ))}
    </div>
  );
};

export default styled(SocialIconsForm)`
  display: flex;
  justify-content: center;
  padding-top: 1rem;
  gap: 0.5rem;
  font-size: 25px;
  opacity: 25%;

  a:nth-child(2) {
    margin: 1rem 1rem;
  }

  .Icon {
    margin: 1rem;
  }
`;
